import { css } from "styled-components";
import { lightThemeClass, darkThemeClass } from "./theme.js";
function makeInternalTokens({
  lightTheme,
  darkTheme
}) {
  const internalTokens = {};
  Object.keys(lightTheme).forEach((key) => {
    internalTokens[key] = `var(--ds-${key})`;
  });
  const declareTokens = css(["&,.", " &{", "}.", " &{", "}"], lightThemeClass, stringifyTokens(lightTheme), darkThemeClass, stringifyTokens(darkTheme));
  return {
    internalTokens,
    declareTokens
  };
}
function stringifyTokens(themeObject) {
  const propertiesAndValues = Object.entries(themeObject).map(([name, value]) => {
    return `--ds-${name}: ${value}`;
  });
  return propertiesAndValues.join(";") + ";";
}
export {
  makeInternalTokens
};
//# sourceMappingURL=makeInternalTokens.js.map
